import FitnessImg from "./img/fitness.gif";
import DatingImg from "./img/circuit.gif";
import JinderImg from "./img/jinder_screen.gif";
import DevImg from "./img/dev_tracker.gif";

export const products = [
  {
    id: 1,
    img: JinderImg,
    link: "https://www.youtube.com/watch?v=paqhE0K8kqc",
    alt: "jinder_app image",
    title: "Jinder: Tinder for Job",
    text: "A full-stack app that provides a platform for job-search and hiring developers",
    github: "https://github.com/alisha0815/jinder",
    desc: (
      <>
        <img
          src="https://icongr.am/devicon/javascript-original.svg?size=128&color=currentColor"
          alt="javascript"
          width="40"
          height="40"
        />
        <img
          src="https://icongr.am/devicon/react-original.svg?size=128&color=currentColor"
          alt="react"
          width="40"
          height="40"
        />
        <img
          src="https://cdn.iconscout.com/icon/free/png-128/typescript-1174965.png"
          alt="chart js"
          width="40"
          height="40"
        />
        <img
          src="https://nodejs.org/static/images/logo.svg"
          alt="nodejs"
          width="40"
          height="40"
        />
        <img
          src="https://icongr.am/devicon/mongodb-original-wordmark.svg?size=128&color=currentColor"
          alt="mongodb"
          width="40"
          height="40"
        />
        <img
          src="https://www.gstatic.com/devrel-devsite/prod/v0e0f589edd85502a40d78d7d0825db8ea5ef3b99ab4070381ee86977c9168730/firebase/images/lockup.svg"
          alt="mongodb"
          width="60"
          height="60"
        />
      </>
    ),
  },

  {
    id: 2,
    img: DevImg,
    link: "https://netlify-thinks-alisha0815-is-great.netlify.app/",
    alt: "dev_Tracker image",
    title: "DevTracker",
    text: "A full-stack app that helps you to keep track of your job application process",
    github: "https://github.com/alisha0815/DevTracker",
    desc: (
      <>
        <img
          src="https://icongr.am/devicon/javascript-original.svg?size=128&color=currentColor"
          alt="javascript"
          width="40"
          height="40"
        />
        <img
          src="https://icongr.am/devicon/react-original.svg?size=128&color=currentColor"
          alt="react"
          width="40"
          height="40"
        />
        <img
          src="http://www.chartjs.org.s3-website-eu-west-1.amazonaws.com/img/chartjs-logo.svg"
          alt="chart js"
          width="40"
          height="40"
        />
        <img
          src="https://icongr.am/devicon/nodejs-original-wordmark.svg?size=128&color=currentColor"
          alt="nodejs"
          width="40"
          height="40"
        />
        <img
          src="https://icongr.am/devicon/mongodb-original-wordmark.svg?size=128&color=currentColor"
          alt="mongodb"
          width="40"
          height="40"
        />
      </>
    ),
  },

  {
    id: 3,
    img: FitnessImg,
    link: "https://personal-trainer-kyledanny.herokuapp.com/",
    alt: "fitness_app image",
    title: "Functional Fitness App",
    text: "A Ruby and rails app that allows users to book their personal trainers",
    github: "https://github.com/alisha0815/Function-Fitness-App",
    desc: (
      <>
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/ruby/ruby-original.svg"
          alt="ruby"
          width="45"
          height="45"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/rails/rails-original-wordmark.svg"
          alt="rails"
          width="60"
          height="60"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
          alt="javascript"
          width="45"
          height="45"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
          alt="html5"
          width="45"
          height="45"
        />
        <img
          src="https://img.icons8.com/color/48/000000/sass.png"
          alt="sass"
          width="45"
          height="45"
        />
        <img
          src="https://www.vectorlogo.zone/logos/figma/figma-icon.svg"
          alt="figma"
          width="45"
          height="45"
        />
      </>
    ),
  },
  {
    id: 4,
    img: DatingImg,
    link: "https://circuit-speed-dating.herokuapp.com/",
    alt: "dating_app image",
    title: "::Circuit Speed Dating App",
    text: "A Ruby and rails app that makes your dating experience safer with face-to-face.",
    github: "https://github.com/alisha0815/Circuit-Speed-Dating",
    desc: (
      <>
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/ruby/ruby-original.svg"
          alt="ruby"
          width="45"
          height="45"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/rails/rails-original-wordmark.svg"
          alt="rails"
          width="60"
          height="60"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
          alt="javascript"
          width="45"
          height="45"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
          alt="html5"
          width="45"
          height="45"
        />
        <img
          src="https://img.icons8.com/color/48/000000/sass.png"
          alt="sass"
          width="45"
          height="45"
        />
        <img
          src="https://www.vectorlogo.zone/logos/figma/figma-icon.svg"
          alt="figma"
          width="45"
          height="45"
        />
      </>
    ),
  },
];
